import React from "react";

const CardSaldos = ({ factura, concepto, saldo }) => {
    let newConcepto = concepto.split(' ');
    return (
        <tr>
            <td>
                {newConcepto[0] + ' ' + (newConcepto[1] || '')}
                <span className="d-block text-muted" style={{ fontSize: '0.78rem' }}>
                    {factura}
                </span>
            </td>
            <td className="text-right">
                <b>${(+saldo).toFixed(2)}</b>
            </td>
        </tr>
    )
};

export default CardSaldos;
